export const DATE_TIME_FORMAT_LOCAL_STORAGE_KEY = 'uiDateTimeFormat';
export const DATE_TIME_FORMAT_CHANGED_EVENT = 'dateTimeFormatChanged';
